import styled from '@emotion/styled';

import ModalLayoutBase, { ModalContent as ModalContentBase } from 'src/components/ModalLayout';

export const ModalLayout = styled(ModalLayoutBase)`
  --background-color: ${({ theme }) => theme.color.bg1};
  border-radius: 24px;
  overflow: hidden;
  ${({ theme }) => theme.screenSize.desktop} {
    width: 960px;
    max-width: 960px;
    min-width: 960px;
    max-height: 840px;
  }
  ${({ theme }) => theme.screenSize.mobile} {
    border-radius: 0;
    overflow: auto;
  }
`;

export const ModalContent = styled(ModalContentBase)`
  padding: 0;
`;

export const MobileCloseButton = styled.button`
  all: unset;
  box-sizing: border-box;
  cursor: pointer;
  display: none;
  position: absolute;
  top: 13px;
  inset-inline-start: 16px;
  z-index: 2;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  padding: 8px;
  color: ${({ theme }) => theme.color.content8};

  & > svg {
    width: 24px;
    height: 24px;
  }

  ${({ theme }) => theme.screenSize.mobile} {
    display: flex;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.color.bg1};

  ${({ theme }) => theme.screenSize.desktop} {
    flex-direction: row;
    min-height: 551px;
  }
`;

export const LeftPanel = styled.div<{ $isHighPlan: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  overflow: hidden;
  padding-top: 52px;

  &::before {
    content: '';
    position: absolute;
    top: -69%;
    inset-inline-start: -21%;
    inset-inline-end: -21%;
    bottom: 45%;
    border-radius: 50%;
    background: ${({ $isHighPlan }) =>
      $isHighPlan ? 'rgba(0, 246, 157, 0.1)' : 'rgba(255, 255, 255, 0.1)'};
    filter: blur(100px);
    z-index: 0;
  }

  ${({ theme }) => theme.screenSize.desktop} {
    padding-top: 0;
    flex: 1;
    justify-content: center;
    gap: 16px;
    padding: 16px 24px 24px;

    &::after {
      content: '';
      position: absolute;
      top: 91%;
      inset-inline-start: 8%;
      inset-inline-end: 8%;
      bottom: -64%;
      border-radius: 50%;
      background: ${({ $isHighPlan }) =>
        $isHighPlan ? 'rgba(0, 246, 157, 0.1)' : 'rgba(255, 255, 255, 0.1)'};
      filter: blur(50px);
      z-index: 0;
    }
  }
`;

export const BlurTopWrapper = styled.div`
  position: absolute;
  top: 0;
  inset-inline-start: 0;
  inset-inline-end: 0;
  height: 130px;
  z-index: 0;
  overflow: hidden;
  pointer-events: none;
`;

export const BlurImage = styled.img<{ $isVisible: boolean }>`
  position: absolute;
  top: 0;
  inset-inline-start: 0;
  width: 100%;
  height: 100%;
  object-fit: fill;
  opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
  transition: opacity 0.2s ease-in-out;
  ${({ theme }) => theme.isRtl && `transform: scaleX(-1);`}
`;

export const TitleSection = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  padding: 16px 24px 24px;
  width: 100%;

  ${({ theme }) => theme.screenSize.desktop} {
    padding: 0;
    max-width: 100%;
  }
`;

export const LabelContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
`;

export const Title = styled.h1`
  margin: 0;
  font-size: 30px;
  font-weight: 700;
  line-height: 40px;
  text-align: center;
  color: ${({ theme }) => theme.color.content12};
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

  ${({ theme }) => theme.screenSize.desktop} {
    font-size: 40px;
    line-height: 56px;
  }
`;

export const FirstTimeDiscountLabel = styled.p`
  padding: 8px 12px;
  background-color: ${({ theme }) => theme.color.primaryDeep};
  border-radius: 8px;
  font-size: 13px;
  font-weight: 700;
  line-height: 16px;
  color: ${({ theme }) => theme.color.primary1};

  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const RightPanel = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  min-width: 0;

  ${({ theme }) => theme.screenSize.desktop} {
    padding-block-start: 24px;
  }
`;

export const TabsWrapper = styled.div`
  padding: 16px 24px;
  width: 100%;
`;

export const ListWrapper = styled.div`
  flex: 1;
  overflow-y: auto;
  width: 100%;

  ${({ theme }) => theme.screenSize.desktop} {
    padding: 0px 24px;
  }
`;
